// PinionTheme.js
import { createTheme } from "@mantine/core";
import globalStyles from '../Global.module.css';
import '@mantine/tiptap/styles.css';
// import CustomIcon from "../components/ui/Icons/CustomIcon";
// import { iconsAndTextColor } from "../components/mantineReactTable/sizes";


const PinionTheme = createTheme({
    colors: {
        default_Blue: [
            '#E7F5FF', //0
            '#D0EBFF', //1
            '#A5D8FF', //2
            '#74C0FC', //3
            '#4DABF7', //4
            '#339AF0', //5
            '#228BE6', //6 
            '#1C7ED6', //7
            '#1971C2', //8
            '#1864AB', //9
        ],
    },
    components: {
        TextInput: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.inputStyle
            },
        },
        DateInput: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.inputStyle
            }
        },

        Select: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.inputStyle
            },
        },


        RadioGroup: {
            classNames: {
                label: globalStyles.radioLabelStyle,
                input: globalStyles.inputStyle
            },
        },

        Checkbox: {
            classNames: {
                label: globalStyles.radioLabelStyle,
            },
        },
        // Button: {
        //     classNames: {
        //         root: globalStyles.buttonStyle,
        //         label: globalStyles.buttonLabel
        //     },
        // },

        FileInput: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.inputStyle
            },
        },

        PasswordInput: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.inputStyle
            }
        },
        MultiSelect: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.inputStyle
            },
        },

        Textarea: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.inputStyle
            },
        },

        ColorInput: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.inputStyle

            },
        },

        Modal: {
            styles: () => ({
                title: {
                    fontSize: "1rem",
                    fontWeight: 700,
                    // fontFamily: "sans-serif",
                },
            }),
        },

        PhoneNumber: {
            classNames: {
                label: globalStyles.phoneNumberWrapper,
                input: globalStyles.phoneNumberWrapper
            },
        },
        NumberInput: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.inputStyle
            },
        },
        DatePickerInput: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.dateInputStyle
            },
        },
        TagsInput: {
            classNames: {
                label: globalStyles.labelStyle,
                input: globalStyles.inputStyle
            },
        },

        Text: {
            defaultProps: {
                fw: 500,
            },
        },
        label: {
            styles: () => ({
                root: {
                    fontWeight: '500',
                },
            }),
        }

        // Drawer: {
        //     styles: () => ({
        //         content: {
        //           backgroundColor: 'transparent',
        //         },
        //         Optional: remove overlay background if needed
        //         overlay: {
        //             backgroundColor: 'rgba(0, 0, 0, 0)', // fully transparent
        //         },
        //     }),
        // },
    },

    headings: {
        sizes: {
            h1: {
                fontSize: '1.8rem',
            },
            h2: {
                fontSize: '1.5rem',
            },
            h3: {
                fontSize: '1.3rem',
            },
            h4: {
                fontSize: '1rem',
            },
            h5: {
                fontSize: '1rem',
            },
            h6: {
                fontSize: '0.9rem',
            },
        },
    },
});

export default PinionTheme;
